import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {Language} from '../../models/language';
import {LanguageService} from '../../service/language.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {

  lang: string = Language.HY;

  private languageSubscription?: Subscription;

  constructor(private languageService: LanguageService) {
  }

  ngOnInit(): void {
    this.lang = this.languageService.getCurrentLanguage();
    this.languageSubscription = this.languageService.currentLanguage$.subscribe(lang => {
      this.lang = lang;
    });
  }

  ngOnDestroy(): void {
    this.languageSubscription?.unsubscribe();
  }

  changeLang(lang: string): void {
    this.languageService.setLanguage(lang);
    this.lang = lang;
  }

  protected readonly Language = Language;
}
